import EventEmitter from 'events';
import * as StatsUtilsDefault from './statsUtils';

const INITIAL_DELAY = 1000;
const INTERVAL = 500;

const createCongestionLevelStats = (getPcStats, deps = {}) => {
  const StatsUtils = deps.StatsUtils || StatsUtilsDefault;
  const ee = new EventEmitter();
  let lastAudioStats;
  let lastVideoStats;

  const resetStats = () => {
    lastAudioStats = undefined;
    lastVideoStats = undefined;
  };

  const calculateAudioProperties = (parsedStats) => {
    const prevLastAudioStats = lastAudioStats;
    lastAudioStats = parsedStats;
    if (parsedStats.audioReportTimestamp === prevLastAudioStats?.audioReportTimestamp) {
      return {};
    }
    if (parsedStats.audioFractionLost !== undefined) {
      return { audioPacketLoss: parsedStats.audioFractionLost };
    }
    if (!prevLastAudioStats) {
      return {};
    }
    return { audioPacketLoss: StatsUtils.getAudioPacketLoss(parsedStats, prevLastAudioStats) };
  };

  const calculateVideoProperties = (parsedStats) => {
    const prevLastVideoStats = lastVideoStats;
    lastVideoStats = parsedStats;
    if (!prevLastVideoStats) {
      return {};
    }
    return {
      videoFramesPerSecond: StatsUtils.getVideoFramesPerSecond(parsedStats, prevLastVideoStats),
      videoPacketLoss: StatsUtils.getVideoPacketLoss(parsedStats, prevLastVideoStats),
    };
  };

  const processStats = (stats) => {
    const parsedStats = StatsUtils.parseStats(stats);

    const { audioPacketLoss } = calculateAudioProperties(parsedStats);
    const { videoFramesPerSecond, videoPacketLoss } = calculateVideoProperties(parsedStats);

    const {
      bandwidth,
      videoWidth,
      videoHeight,
      videoSourceWidth,
      videoSourceHeight,
      videoSourceFramesPerSecond,
    } = parsedStats;

    ee.emit('statsAvailable', {
      audioPacketLoss,
      videoPacketLoss,
      bandwidth,
      videoWidth,
      videoHeight,
      videoFramesPerSecond,
      videoSourceWidth,
      videoSourceHeight,
      videoSourceFramesPerSecond,
      stats,
    });
  };

  const getStats = () => {
    getPcStats((err, stats) => {
      if (!err) {
        processStats(stats);
      }
    });
  };

  let cancelId;
  return Object.assign(ee, {
    start() {
      if (cancelId) {
        // already started
        return;
      }
      cancelId = setTimeout(() => {
        getStats();
        cancelId = setInterval(() => {
          getStats();
        }, INTERVAL);
      }, INITIAL_DELAY);
    },

    stop() {
    // Note that clearInterval and clearTimeout are interchangeable
      clearInterval(cancelId);
      cancelId = undefined;
      resetStats();
    },
  });
};

export default createCongestionLevelStats;
